import { Button, Stack } from "@mui/material";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  message: string;
  onRetry: () => void;
};

export const ErrorWithRetry = ({ message, onRetry }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={2} alignItems="center" px={2}>
      <ErrorText>{message}</ErrorText>
      <Button variant="outlined" onClick={onRetry}>
        {t(Resources.Common.Retry)}
      </Button>
    </Stack>
  );
};
